import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Input,
  OnDestroy
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {MatStepper, MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import Swal from 'sweetalert2';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatTooltipModule} from '@angular/material/tooltip';

import {DomSanitizer, SafeResourceUrl,} from '@angular/platform-browser';
import {HeaderComponent} from '../../header/header.component';
import {FooterComponent} from '../../footer/footer.component';
import {NumericDirective2} from '../../../validaciones/directives/numeric.directive';
import {PlacaDirective} from '../../../validaciones/directives/placa.directive';
import {MatIconModule} from '@angular/material/icon';
import {ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';

import {
  distinctUntilChanged,
  filter,
  fromEvent,
  map,
  Subject, Subscription,
  switchMap,
  takeUntil,
  tap
} from 'rxjs';
import {validadorReutilizable} from '../../../shared/utils/validadores';
import {ConsultarEstatusVehiculoMoralService} from '../../../service/consultarEstatusVehiculoMoral.service';
import {SolicitarCertificadoEstatalMoralService} from '../../../service/solicitarCertificadoEstatalMoral.service';
import {CatEfectoCertificado} from '../../../service/catEfectoCertificado.service';
import {CatCoberturaCertificados} from '../../../service/catCoberturaCertificados.service';
import {SolicitudVo} from '../../../pojos/solicitudVo';
import {ImprimirSolicitudCdniGenerico} from '../../../service/imprimirSolicitudCdniGenerico.service';
import {DocumentoService} from '../../../service/cargarDocumentos.service';
import {HttpEventType, HttpEvent} from '@angular/common/http';
import {EliminarDocumentos} from '../../../service/eliminarDocumentos.service';
import {AlphanumericDirective2, lettersDirective} from '../../../validaciones/directives/lettersDirective.directive';
import {EditarSolicitudMoralService} from '../../../service/solicitarInformacionEdicionMoral.service';
import {EdicionVehiculoResponseMoralVo, DocumentoVO} from '../../../pojos/EdicionVehiculoResponseMoralVo';
import {GuardarEdicionService} from '../../../service/guardarEdicion.service';
import {CatalogoDomicilioGenericoService} from '../../../service/catalogoDomicilioGenerico.service';
import {DireccionDirective} from '../../../validaciones/directives/direccion.directive';
import {toUpercaseDirective} from '../../../validaciones/directives/toUpercase.Direcitve';
import { AlphanumericDirective } from '../../../validaciones/directives/alphanumeric.directive';

// --- Interfaces para los nuevos Payloads de guardado ---
export interface DocumentoPayload {
  idDocumento: string;
  url: string;
  idDocumentoTramite: number;
  nombreDocumento: string;
}

export interface PayloadEdicionEstatal {
  dataEncript: string;
  documentoList: DocumentoPayload[];
}

export interface PayloadEdicionForaneo {
  dataEncript: string;
  strNiv: string;
  strPlaca: string;
  strMarca: string;
  strSubMarca: string;
  strCategoria: string;
  strModelo: string;
  strMotor: string;
  strRepuve: string;
  strRefrendo: string;
  strRfc: string;
  strRazonSocial: string;
  strFechaConstitucion: string;
  strRfcRepresentante: string;
  strCurpRepresentante: string;
  strNombreRepresentante: string;
  strApPaternoRepresentante: string;
  strApMaternoRepresentante: string;
  strSexoRepresentante: string;
  strFechaNacimientoRepresentante: string;
  strCalleFiscal: string;
  strNumeroExteriorFiscal: string;
  strNumeroInteriorFiscal: string;
  strCodigoPostalFiscal: string;
  strEstadoFiscal: string;
  strMunicipioFiscal: string;
  strLocalidadFiscal: string;
  intiICodigoPostalCg: number;
  // Estos campos parecen faltar en tu formulario, si son necesarios, habría que añadirlos
  intIdEstadoFiscal: number;
  intIdMunicipioFiscal: number;
  //   intIdLocalidadFiscal: number;
  documentoList: DocumentoPayload[];
}

@Component({
  selector: 'app-persona-moral-estatal-edicion',
  imports: [ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatOptionModule,
    HeaderComponent,
    FooterComponent,
    MatCheckboxModule,
    FormsModule,
    CommonModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,

    /*
        NumericDirective,
    */
    AlphanumericDirective,
    PlacaDirective,
    /*    TrimOnBlurDirective,
        NameDirective,*/
    lettersDirective,
    NumericDirective2,
    AlphanumericDirective2,
    DireccionDirective,
    toUpercaseDirective
  ],
  templateUrl: './persona-moral-edicion.component.html',
  standalone: true,
  styleUrl: './persona-moral-edicion.component.css'
})
export class PersonaMoralEdicionComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('rfcMoralInput', {static: false}) rfcMoralInput!: ElementRef;
  @ViewChild('fechaConstitucionInput', {static: false}) fechaConstitucionInput!: ElementRef;
  @ViewChild('sexoInput', {static: false}) sexoInput!: ElementRef;
  @ViewChild('fechaNacimientoInput', {static: false}) fechaNacimientoInput!: ElementRef;
  @Input() localidad: Array<any> = [];
  @Input() municipio!: string;
  @Input() asentamiento: Array<any> = [];
  @Input() estado!: string;
  @Input() idMunicipio!: string;
  @Input() idEstado!: string;
  @Input() cp!: any;
  @Input() Message!: string;
  private consultaExitosaRealizada = false;
  private rfcMoralIncompletoDelServicio: string | null = null;
  // --- Propiedades para la lógica de edición ---
  private dataEncript: string | null = null;
  private tipoServicioId: number | null = null;
  public esTramiteEstatal: boolean = false;
  public esForaneo: boolean = false;
  public tituloTramite: string = 'PERSONA: MORAL';
  private readonly BASE_URL_DOCUMENTOS = 'https://af-documentos-pdf-cdni.sefintlax.gob.mx';


  //*****************Variables para grupos stepper******************
  PrimerFormGroup!: FormGroup;
  SegundoGrupo!: FormGroup;
  TercerFormGroup!: FormGroup;
  CuartoFormGroup!: FormGroup;
  QuintoFormGroup!: FormGroup;
  SextoFormGroup!: FormGroup;
  SeptimoFormGroup!: FormGroup;
  //*****************Terminan variables para grupos stepper******************

  mostrarSpinner = false;
  isLinear = false;

  /****************variables para uso de cronometro de boton para descargar documentos***************/

  @Input() efectosCertificados: any[] = [];
  @Input() coberturaCertificados: any[] = [];
  @Input() solicitudVo!: SolicitudVo;
  private subCodigoPostal!: Subscription;

  isUploading: { [key: string]: boolean } = {};
  uploadProgress: { [key: string]: number } = {};

  private destroy$ = new Subject<void>();

  constructor(
    private _formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private vehiculoService: ConsultarEstatusVehiculoMoralService,
    private solicitudService: SolicitarCertificadoEstatalMoralService,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private edicionMoralService: EditarSolicitudMoralService, // Servicio para cargar datos
    private cd: ChangeDetectorRef,
    private catEfectoCertificadoService: CatEfectoCertificado,
    private catCoberturaCertificadoService: CatCoberturaCertificados,
    private imprimirSolicitudService: ImprimirSolicitudCdniGenerico,
    private documentoService: DocumentoService,
    private eliminarDocumentoService: EliminarDocumentos,
    private guardarEdicionService: GuardarEdicionService,
    private catalogoDomicilioGenerico: CatalogoDomicilioGenericoService,
    private router: Router,
  ) {
    this.solicitudVo = new SolicitudVo();
    this.catCoberturaCertificados();
    this.catEfectoCertificado();
  }

  ngOnInit(): void {
    this.PrimerFormGroup = this._formBuilder.group({
      niv: ['', [ validadorReutilizable({
        blnPermitirLetras: true,
        blnPermitirNumeros: true,
        intLongitudMinima: 10, // Estandarizado
        intLongitudMaxima: 17
      })]],
      placa: ['', [ validadorReutilizable({
        blnPermitirLetras: true,
        blnPermitirNumeros: true,
        blnPermitirGuionMedio: true, intLongitudMinima: 6, intLongitudMaxima: 10
      })]],
      motivo: [''],
      certificadoPor: [''],
      tipoServicio: [''],
      categoria: [''],
      marca: [''],
      submarca: [''],
      modelo: ['', [ Validators.pattern('^[0-9]{4}$')]], // Estandarizado
      motor: [''],
      refrendo: ['', [Validators.pattern('^[0-9]{4}$')]], // Estandarizado
      repuve: [''],
    });

    this.SegundoGrupo = this._formBuilder.group({
      rfcMoral: ['', [ Validators.pattern(/^[A-ZÑ&]{3}[0-9]{6}[A-Z0-9]{3}$/i)]], // Estandarizado
      fechaConstitucion: [''],
      razonSocial: ['', [ // Estandarizado
        validadorReutilizable({
          blnPermitirCaracteresEspecialesEmpresa: true,
          blnPermitirPuntos: true,
          blnPermitirEspacios: true,
          blnPermitirAcentos: true,
        })
      ]],
      calle: [''],
      numExterior: [''],
      numInterior: [''],
      codigoPostal: ['', [ Validators.pattern('^[0-9]{5}$')]],
      estado: [''],
      municipio: [''],
      localidad: [''],
    });

    this.TercerFormGroup = this._formBuilder.group({
      numeroTelefono: ['', [ Validators.pattern(/^\d{10}$/)]],
      correoElectronico: ['', [ Validators.pattern(/^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
    });

    this.CuartoFormGroup = this._formBuilder.group({
      rfc: ['', [ Validators.pattern(/^[A-ZÑ&]{4}\d{6}[A-Z\d]{3}$/i)]],
      curp: ['', [ Validators.pattern(/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/)]], // Estandarizado
      nombre: ['', [ // Estandarizado
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirEspacios: true,
          blnPermitirPuntos: true,
          blnPermitirAcentos: true,
        })
      ]],
      apellidoPaterno: ['', [ // Estandarizado
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirEspacios: true,
          blnPermitirPuntos: true,
          blnPermitirAcentos: true,
        })
      ]],
      apellidoMaterno: ['', [ // Estandarizado
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirEspacios: true,
          blnPermitirPuntos: true,
          blnPermitirAcentos: true,
        })
      ]],
      sexo: [''],
      fechaNacimiento: [''],
    });

    this.QuintoFormGroup = this._formBuilder.group({
      documentos: [false, Validators.requiredTrue],
    });

    this.SextoFormGroup = this._formBuilder.group({
      actaConstitutiva: ['', Validators.required],
      factura: ['', Validators.required],
      ine: ['', Validators.required],
      poderNotarial: ['', Validators.required],
      repuveDoc: ['', Validators.required],
      solicitud: ['', Validators.required],
      tenencia: [''], // Estandarizado
    });

    this.SeptimoFormGroup = this._formBuilder.group({
      terminosCondiciones: [false, Validators.requiredTrue],
    });

    // --- Lógica específica del componente de edición (se mantiene) ---
    this.cambiarEstadoConCodigoPostal();

    this.route.paramMap.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      const data = params.get('data') || '';
      this.dataEncript = data.substring(5);
      if (this.dataEncript) {
        this.cargarDatosSolicitud(this.dataEncript);
      } else {
        Swal.fire('Error', 'No se encontró un identificador para cargar la información de la solicitud.', 'error');
      }
    });

    this.inicializarValidacionesReactivas();
  }

  private suscribirseACodigoPostal(): void {
    this.subCodigoPostal = this.SegundoGrupo.get('codigoPostal')?.valueChanges
      .pipe(
        distinctUntilChanged(),
        filter(value => value?.length === 5 && this.esForaneo)
      )
      .subscribe(value => {
        this.getListlocalidad(value);
      })!;
  }

  ngAfterViewInit() {
    // ========== INICIA CÓDIGO PARA VALIDACIÓN DE RFC MORAL ==========
    const rfcMoralControl = this.SegundoGrupo.get('rfcMoral');
    if (rfcMoralControl) {
      // Asegurarse de que el elemento exista antes de agregar el listener
      const rfcMoralField = this.elementRef.nativeElement.querySelector('[formControlName="rfcMoral"]');
      if (rfcMoralField) {
        fromEvent(rfcMoralField, 'blur').pipe(
          filter(() => rfcMoralControl.valid && rfcMoralControl.value.length === 12),
          map(() => rfcMoralControl.value),
          takeUntil(this.destroy$)
        ).subscribe(() => {
          const fechaInferida = this.inferirFechaConstitucion(rfcMoralControl.value);
          if (fechaInferida) {
            this.SegundoGrupo.get('fechaConstitucion')?.setValue(fechaInferida);
            this.aplicarEstilosDeshabilitado(this.fechaConstitucionInput);
          }
        });

        rfcMoralControl.valueChanges.pipe(
          filter(() => rfcMoralControl.invalid),
          takeUntil(this.destroy$)
        ).subscribe(() => {
          const fechaConstitucionControl = this.SegundoGrupo.get('fechaConstitucion');
          if (rfcMoralControl.invalid) {
            fechaConstitucionControl?.reset('');
            this.removerEstilosDeshabilitado(this.fechaConstitucionInput);
          }
        });
      }
    }
    // ========== TERMINA CÓDIGO PARA VALIDACIÓN DE RFC MORAL ==========

    // ========== INICIA CÓDIGO PARA INFERIR DATOS DESDE CURP ==========
    const curpControl = this.CuartoFormGroup.get('curp'); // Ajustado a CuartoFormGroup
    if (curpControl) {
      const curpField = this.elementRef.nativeElement.querySelector('[formControlName="curp"]');
      if (curpField) {
        fromEvent(curpField, 'blur').pipe(
          filter(() => curpControl.valid && curpControl.value.length === 18),
          map(() => curpControl.value),
          takeUntil(this.destroy$)
        ).subscribe(() => {
          const datosInferidos = inferirDatosDesdeCurp(curpControl.value);
          const sexoControl = this.CuartoFormGroup.get('sexo');
          const fechaNacimientoControl = this.CuartoFormGroup.get('fechaNacimiento');

          if (datosInferidos && sexoControl && fechaNacimientoControl) {
            sexoControl.setValue(datosInferidos.sexo);
            fechaNacimientoControl.setValue(datosInferidos.fechaNacimiento);
            this.aplicarEstilosDeshabilitado(this.sexoInput);
            this.aplicarEstilosDeshabilitado(this.fechaNacimientoInput);
          }
        });

        curpControl.valueChanges.pipe(
          filter(() => curpControl.invalid),
          takeUntil(this.destroy$)
        ).subscribe(() => {
          const sexoControl = this.CuartoFormGroup.get('sexo');
          const fechaNacimientoControl = this.CuartoFormGroup.get('fechaNacimiento');

          if (curpControl.invalid) {
            sexoControl?.reset('');
            fechaNacimientoControl?.reset('');
            this.removerEstilosDeshabilitado(this.sexoInput); // Cambiado para remover estilos
            this.removerEstilosDeshabilitado(this.fechaNacimientoInput); // Cambiado para remover estilos
          }
        });
      }
    }
    // ========== TERMINA CÓDIGO PARA INFERIR DATOS DESDE CURP ==========
  }


  aplicarEstilosDeshabilitado(elemento: ElementRef): void {
    if (elemento && elemento.nativeElement) {
      const el = elemento.nativeElement;
      el.style.pointerEvents = 'none';
      el.style.opacity = '0.7';
      el.style.backgroundColor = '#f5f5f5';
      el.setAttribute('aria-disabled', 'true');
      el.tabIndex = -1;
    }
  }

  inferirFechaConstitucion(rfc: string): string | null {
    // 1. Validar que el RFC sea una cadena y tenga 12 caracteres.
    if (typeof rfc !== 'string' || rfc.length !== 12) {
      console.error();
      return null;
    }

    try {
      // 2. Extraer la subcadena YYMMDD (posiciones 3 a 8).
      const fechaSubstr = rfc.substring(3, 9);

      // 3. Separar las partes de la fecha.
      const anioDosDigitos = parseInt(fechaSubstr.substring(0, 2), 10);
      const mes = fechaSubstr.substring(2, 4);
      const dia = fechaSubstr.substring(4, 6);

      // 4. Determinar el siglo.
      const anioActualDosDigitos = new Date().getFullYear() % 100;
      const siglo = (anioDosDigitos > anioActualDosDigitos) ? '19' : '20';

      // 5. Formatear la fecha final en YYYY-MM-DD.
      const anioCompleto = siglo + anioDosDigitos.toString().padStart(2, '0');

      const fechaFormateada = `${anioCompleto}-${mes}-${dia}`;

      // Opcional: Validar que la fecha construida sea una fecha real.
      const fechaObjeto = new Date(fechaFormateada);
      if (isNaN(fechaObjeto.getTime())) {

        return null;
      }

      return fechaFormateada;

    } catch (error) {
      console.error(error);
      return null;
    }
  }

  removerEstilosDeshabilitado(elemento: ElementRef): void {
    if (elemento && elemento.nativeElement) {
      const el = elemento.nativeElement;
      el.style.pointerEvents = 'auto';
      el.style.opacity = '1';
      el.style.backgroundColor = 'white';
      el.removeAttribute('aria-disabled');
      el.tabIndex = 0;
    }
  }

  cargarDatosSolicitud(data: string): void {
    this.mostrarSpinner = true;
    this.edicionMoralService.editarSolicitudMoral(data).subscribe({
      next: (respuesta) => {
        this.mostrarSpinner = false;
        if (respuesta && respuesta.intCodigoHttp === 200) {

          this.tipoServicioId = respuesta.datosVehiculoResponseVo.intIdTipoTramite;
          this.esTramiteEstatal = this.tipoServicioId === 1;
          this.esForaneo = this.tipoServicioId === 2;
          this.actualizarValidadores(!this.esTramiteEstatal);
          this.poblarFormularios(respuesta);
          if (this.esForaneo) {
            this.tituloTramite = 'PERSONA: MORAL - FORÁNEO';
            let codigoPostalCg = respuesta.datosDomicilioResponseVo.intIdCodigoPostal
            this.getListlocalidadExacta(codigoPostalCg.toString());
          } else {
            this.tituloTramite = 'PERSONA: MORAL - ESTATAL';
          }
          this.inicializarListaDocumentos();

          this.procesarURLsDocumentos(respuesta.documentoList);
          this.configurarEstadoFormulario();

        } else {
          Swal.fire('Error', /*respuesta.strMensaje ||*/ 'No se pudieron cargar los datos de la solicitud.', 'error');
        }
      },
      error: () => {
        this.mostrarSpinner = false;
        Swal.fire('Error de Comunicación', 'No se pudo conectar con el servidor para obtener los datos.', 'error');
      }
    });
  }

  private actualizarValidadores(esRequerido: boolean): void {
    // Lista de todos los controles de todos los grupos que necesitan validación dinámica
    const controles = [
      // PrimerFormGroup
      this.PrimerFormGroup.get('niv'), this.PrimerFormGroup.get('placa'),
      this.PrimerFormGroup.get('motivo'), this.PrimerFormGroup.get('certificadoPor'),
      this.PrimerFormGroup.get('tipoServicio'), this.PrimerFormGroup.get('categoria'),
      this.PrimerFormGroup.get('marca'), this.PrimerFormGroup.get('submarca'),
      this.PrimerFormGroup.get('modelo'), this.PrimerFormGroup.get('motor'),
      this.PrimerFormGroup.get('refrendo'), this.PrimerFormGroup.get('repuve'),

      // SegundoGrupo
      this.SegundoGrupo.get('rfcMoral'), this.SegundoGrupo.get('fechaConstitucion'),
      this.SegundoGrupo.get('razonSocial'), this.SegundoGrupo.get('calle'),
      this.SegundoGrupo.get('numExterior'), this.SegundoGrupo.get('numInterior'),
      this.SegundoGrupo.get('codigoPostal'), this.SegundoGrupo.get('estado'),
      this.SegundoGrupo.get('municipio'), this.SegundoGrupo.get('localidad'),

      // TercerFormGroup
      this.TercerFormGroup.get('numeroTelefono'), this.TercerFormGroup.get('correoElectronico'),

      // CuartoFormGroup
      this.CuartoFormGroup.get('rfc'), this.CuartoFormGroup.get('curp'),
      this.CuartoFormGroup.get('nombre'), this.CuartoFormGroup.get('apellidoPaterno'),
      this.CuartoFormGroup.get('apellidoMaterno'), this.CuartoFormGroup.get('sexo'),
      this.CuartoFormGroup.get('fechaNacimiento'),

      // SextoFormGroup
      this.SextoFormGroup.get('tenencia'),
    ];

    for (const control of controles) {
      if (control) {
        if (esRequerido) {
          // Añade el validador 'required' si no lo tiene
          control.addValidators(Validators.required);
        } else {
          // Quita el validador 'required'
          control.removeValidators(Validators.required);
        }
        // Actualiza el estado del control para que los cambios surtan efecto
        control.updateValueAndValidity();
      }
    }
  }


  private getListlocalidadExacta(IdCodigoPostal: string): void {
    // Si el código postal está vacío, reseteamos los valores relacionados
    if (!IdCodigoPostal || IdCodigoPostal.trim() === '') {
      this.resetLocalidadData();
      return;
    }

    // Llamada al servicio para obtener las localidades del código postal
    this.catalogoDomicilioGenerico.getlocalidadExacta(IdCodigoPostal).subscribe((postal: any) => {
      this.cp = postal;

      // Si no se encontraron resultados (array vacío)
      if (!postal || postal.idCodigoPostal == null) {

        Swal.fire({
          html: 'No se encontraron datos para el Código Postal ingresado.',
          icon: 'warning',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Aceptar'
        });

        this.resetLocalidadData(); // Restablecemos los datos si no hay resultados
        return;
      }
      this.localidad = [postal];

      //  Guardamos los datos obtenidos
      this.municipio = postal.descripcionIdMunicipioCodigoPostal;
      this.estado = postal.descripcionidEstadoPais;
      this.idMunicipio = postal.idMunicipioCodigoPostal;
      this.idEstado = postal.idEstadoPais;
      this.asentamiento = postal.idCodigoPostal;
      // 🔹 Actualizar Formulario Reactivo (`SegundoGrupo`)
      this.SegundoGrupo.patchValue({
        estado: this.estado,
        municipio: this.municipio,
        localidad: postal.idCodigoPostal
        //localidad: this.localidad,
        // localidad: this.asentamiento
      });
    });
  }

  private getListlocalidad(codigoPostal: string): void {
    // Si el código postal está vacío, reseteamos los valores relacionados
    if (!codigoPostal || codigoPostal.trim() === '') {
      this.resetLocalidadData();
      return;
    }

    // Llamada al servicio para obtener las localidades del código postal
    this.catalogoDomicilioGenerico.getlocalidad(codigoPostal).subscribe((postal: any) => {
      this.cp = postal;

      // Si no se encontraron resultados (array vacío)
      if (!postal || postal.length === 0) {
        Swal.fire({
          html: 'No se encontraron datos para el Código Postal ingresado.',
          icon: 'warning',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Aceptar'
        });

        this.resetLocalidadData(); // Restablecemos los datos si no hay resultados
        return;
      }

      // 🔹 Guardamos los datos obtenidos
      this.localidad = postal;
      const primerRegistro = this.localidad[0];
      this.municipio = primerRegistro.descripcionIdMunicipioCodigoPostal;
      this.estado = primerRegistro.descripcionidEstadoPais;
      this.idMunicipio = primerRegistro.idMunicipioCodigoPostal;
      this.idEstado = primerRegistro.idEstadoPais;

      if (this.estado.toUpperCase() === 'TLAXCALA') {
        Swal.fire({
          icon: 'error',
          title: 'Estado no Válido',
          // Mensaje mejorado para guiar al usuario
          text: 'Este es un trámite para vehículos foráneos. Si su domicilio fiscal está en TLAXCALA, por favor utilice el trámite para vehículos ESTATALES.',
          confirmButtonColor: '#41bd00',
          confirmButtonText: 'Confirmar',
        });

        // Reseteamos los datos del domicilio y también el campo de código postal
        this.resetLocalidadData();
        this.SegundoGrupo.get('codigoPostal')?.setValue('');
        return; // Detenemos la ejecución para no autocompletar el formulario.
      }

      // 🔹 Actualizar Formulario Reactivo (`tresFormGroup`)
      this.SegundoGrupo.patchValue({
        estado: this.estado,
        municipio: this.municipio,
        localidad: '' // ❗ Forzamos a que localidad esté vacía
      });

      // ❗ Marcar localidad como "pendiente" para que NO sea válida automáticamente
      // this.SegundoGrupo.get('localidad')?.markAsPending();
    });
  }

  /**
   * Méto do para limpiar la información relacionada con el código postal.
   */
  private resetLocalidadData(): void {
    // Limpiar datos relacionados en el componente
    this.localidad = [];
    this.cp = null;
    this.municipio = '';
    this.estado = '';
    this.idMunicipio = '';

    // Reiniciar valores del formulario
    this.SegundoGrupo.patchValue({
      estado: '',
      municipio: '',
      localidad: ''
    });

    // console.log("ℹ️ Datos de localidad reiniciados debido a un código postal vacío.");
  }

  // Método para gestionar cambios en el código postal
  private cambiarEstadoConCodigoPostal(): void {
    const codigoPostalControl = this.SegundoGrupo.get('codigoPostal');

    // Detectar cambios en el campo de código postal
    codigoPostalControl?.valueChanges.subscribe((valor: string) => {
      const estadoControl = this.SegundoGrupo.get('estado');
      const municipioControl = this.SegundoGrupo.get('municipio');
      const localidadControl = this.SegundoGrupo.get('localidad');

      // Validar si el código postal no es válido o tiene menos de 5 caracteres
      if (!codigoPostalControl.valid || valor.length < 5) {
        // Limpia los campos relacionados
        estadoControl?.setValue('');
        municipioControl?.setValue('');
        localidadControl?.setValue('');

        // Marcar los campos como no válidos
        estadoControl?.setErrors({invalid: true});
        municipioControl?.setErrors({invalid: true});
        localidadControl?.setErrors({invalid: true});

        // Opcional: Mostrar mensajes de error al usuario
        estadoControl?.markAsTouched();
        municipioControl?.markAsTouched();
        localidadControl?.markAsTouched();
      } else {
        // Si el código postal es válido, eliminar errores
        estadoControl?.setErrors(null);
        municipioControl?.setErrors(null);
        localidadControl?.setErrors(null);
      }
    });
  }

  /**
   * Rellena todos los formularios con los datos recibidos del servicio.
   */
  poblarFormularios(data: EdicionVehiculoResponseMoralVo): void {
    const vehiculo = data.datosVehiculoResponseVo;
    const persona = data.datosPersonaResponseVo;
    const domicilio = data.datosDomicilioResponseVo;
    const representante = data.datosRepresentanteLegalResponseVo;
    const contacto = data.datosDeContactoResponseVo;

    this.PrimerFormGroup.patchValue({
      niv: vehiculo.strNiv,
      placa: vehiculo.strPlaca,
      motivo: vehiculo.intIdMotivoSolicitud,
      certificadoPor: vehiculo.intIdCertificadoPor,
      tipoServicio: vehiculo.intIdTipoServicio,
      categoria: vehiculo.strCategoria,
      marca: vehiculo.strMarca,
      submarca: vehiculo.strSubMarca,
      modelo: vehiculo.strModelo,
      motor: vehiculo.strNoMotor,
      repuve: vehiculo.strRepuve,
      refrendo: vehiculo.strAnioRefrendo
    });

    this.SegundoGrupo.patchValue({
      rfcMoral: persona.strRfc,
      fechaConstitucion: persona.strFechaConstitucion,
      razonSocial: persona.strRazonSocial,
      calle: domicilio.strCalle,
      numExterior: domicilio.strNoExterior,
      numInterior: domicilio.strNoInterior,
      codigoPostal: domicilio.strCodigoPostal,
      estado: domicilio.strEstado,
      municipio: domicilio.strMunicipio,
    });
    if (vehiculo.intIdTipoTramite == 1) {
      this.localidad = [{
        idCodigoPostal: domicilio.strCodigoPostal,
        asentamiento: domicilio.strLocalidad
      }];

      this.SegundoGrupo.patchValue({
        localidad: domicilio.strCodigoPostal
      })
    }

    this.TercerFormGroup.patchValue({
      numeroTelefono: contacto.strTelefono,
      correoElectronico: contacto.strCorreoElectronico
    });

    this.CuartoFormGroup.patchValue({
      rfc: representante.strRfc,
      nombre: representante.strNombre,
      apellidoPaterno: representante.strApPaterno,
      apellidoMaterno: representante.strApMaterno,
      curp: representante.strCurp
      // La CURP, sexo y fecha de nacimiento se pueden inferir o rellenar si vienen del servicio
    });
    this.suscribirseACodigoPostal();

    const datosInferidos = inferirDatosDesdeCurp(this.CuartoFormGroup.get('curp')?.value)
    const sexoControl = this.CuartoFormGroup.get('sexo');
    const fechaNacimientoControl = this.CuartoFormGroup.get('fechaNacimiento');
    if (datosInferidos && sexoControl && fechaNacimientoControl) {
      // Llenar los campos
      sexoControl.setValue(datosInferidos.sexo);
      fechaNacimientoControl.setValue(datosInferidos.fechaNacimiento);

    }
  }

  configurarEstadoFormulario(): void {
    if (this.esTramiteEstatal) {
      // Envolvemos la línea en un setTimeout para asegurar que el stepper ya exista.
      setTimeout(() => {
        this.stepper.selectedIndex = 4; // Ir directamente al paso de documentos.
      }, 0);
    }
  }

  /**
   * Construye las URLs completas para los documentos y las asigna para visualización.
   */
  procesarURLsDocumentos(documentosServidor: DocumentoVO[]): void {
    documentosServidor.forEach(docServidor => {
      const docLocal = this.documentos.find(d => d.id === docServidor.idDocumentoTramite.toString());
      if (docLocal) {
        docLocal.idDocumentoBack = docServidor.idDocumento;
        docLocal.nombreEncriptado = docServidor.nombreDocumento;
        docLocal.estatus = docServidor.estatus;

        const urlFinal = docServidor.url?.startsWith('/tmp/documentos-pdf')
          ? `${this.BASE_URL_DOCUMENTOS}${docServidor.url.substring(19)}`
          : docServidor.url;

        docLocal.rawUrl = urlFinal;
        docLocal.urlVisor = this.sanitizer.bypassSecurityTrustResourceUrl(urlFinal);

        // Set form control si aplica
        this.SextoFormGroup.get(docLocal.formControlName)?.setValue(docLocal.idDocumentoBack);
      }
    });
  }


  onChangeTipoServicio(event: any) {
    this.solicitudVo.strTipoServicio = event.target.value;

  }

  //********************************************* VALIDACIONES REACTIVAS (SIN CAMBIOS) ************************************************//

  get todosLosFormGroups(): FormGroup[] {
    return [
      this.PrimerFormGroup, this.SegundoGrupo, this.TercerFormGroup,
      this.CuartoFormGroup, this.QuintoFormGroup, this.SextoFormGroup, this.SeptimoFormGroup
    ];
  }

  private inicializarValidacionesReactivas(): void {
    this.todosLosFormGroups.forEach(formGroup => {
      if (!formGroup || !(formGroup instanceof FormGroup)) return;
      Object.keys(formGroup.controls).forEach(campo => {
        // if (this.camposIgnoradosValidacionReactiva.includes(campo)) return;

        const control = formGroup.get(campo);
        if (control) {
          control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.actualizarEstilosCampo(campo, control);
          });
        }
      });
    });
  }

  private actualizarEstilosCampo(campo: string, control: AbstractControl): void {
    const fieldElement = document.querySelector(`[formControlName="${campo}"]`);
    if (fieldElement) {
      if ((control.touched || control.dirty) ||
        ((campo === 'rfcMoral' || campo === 'fechaConstitucion' || campo === 'sexo' || campo === 'fechaNacimiento'
          || campo === 'estado' || campo === 'municipio') && control.valid)) {
        if (control.valid) {
          fieldElement.classList.remove('is-invalid');
          fieldElement.classList.add('is-valid');
        } else {
          fieldElement.classList.add('is-invalid');
          fieldElement.classList.remove('is-valid');
        }
      } else {
        fieldElement.classList.remove('is-valid', 'is-invalid');
      }
    }
  }

  //********************************************* STEPPER Y MENSAJES DE ERROR ************************************************//
  validarYContinuar(campos: { grupo: FormGroup; nombres: string[] }) {
    let primerCampoInvalido: string | null = null;
    for (const campo of campos.nombres) {
      const control = campos.grupo.get(campo);

      if (!control || control.disabled) {          // ⬅️  Salta controles inexistentes o deshabilitados
        continue;
      }
      control.markAsTouched();

      // 1️⃣  Solo márcalo como tocado si REALMENTE está inválido
      if (control.invalid) {
        control.markAsTouched();
        if (!primerCampoInvalido) primerCampoInvalido = campo;
      }

      // 2️⃣  Actualiza estilos (quita / pone is‑invalid)
      this.actualizarEstilosCampo(campo, control);
    }

    if (!primerCampoInvalido) {
      this.stepper.next();
    } else {
      Swal.fire({
        html: this.mensajeError(primerCampoInvalido),
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      // Opcional: Foco en el primer campo inválido
      const fieldElement = document.querySelector(`[formControlName="${primerCampoInvalido}"]`) as HTMLElement;
      fieldElement?.focus();
    }
  }

  mensajeError(campo: string): string {
    const control = this.todosLosFormGroups.reduce((acc, fg) => acc || fg.get(campo), null as AbstractControl | null);
    if (control && control.errors) {
      if (control.errors['required']) {
        // Mensajes genéricos para 'required' pueden ser suficientes si los nombres de campo son claros
      }
      // Podrías añadir más lógica para errores específicos como pattern, minlength, etc.
    }

    const mensajes: any = {
      niv: 'El campo <b> NIV de los Datos del Vehículo </b> no debe estar vacío.',
      placa: 'El campo <b> Placa de los Datos del Vehículo </b> no debe estar vacío.',
      motivo: 'El campo <b> Motivo de Solicitud de los Datos del Vehículo </b> debe estar seleccionado.',
      certificadoPor: 'El campo <b> Certificado Por.. de los Datos del Vehículo </b> debe estar seleccionado.',
      tipoServicio: 'El campo <b> Tipo Servicio de los Datos del Vehículo </b> debe estar seleccionado.',
      categoria: 'El campo <b> Categoria de los Datos del Vehículo </b> no debe estar vacío.',
      marca: 'El campo <b> Marca de los Datos del Vehículo </b> no debe estar vacío.',
      submarca: 'El campo <b> Submarca de los Datos del Vehículo </b> no debe estar vacío.',
      modelo: 'El campo <b> Modelo de los Datos del Vehículo </b> no debe estar vacío.',
      motor: 'El campo <b> Motor de los Datos del Vehículo </b> no debe estar vacío.',
      refrendo: 'El campo <b> Refrendo de los Datos del Vehículo </b> no debe estar vacío.',
      repuve: 'El campo <b> Repuve de los Datos del Vehículo </b> no debe estar vacío.',
      rfcMoral: 'Por favor verifica que el campo <b> RFC </b> no este vacío o que el formato proporcionado sea válido.<br><b> formato válido: </b> LLL000000AAA',
      fechaConstitucion: 'El campo <b> Fecha constitucion de los Datos de la empresa </b> no debe estar vacío.',
      razonSocial: 'El campo <b> Razon social de los Datos de la empresa </b> no debe estar vacío.',
      calle: 'El campo <b> Calle del Domicilio Fiscal </b> no debe estar vacío.',
      numExterior: 'El campo <b> Numero Exterior del Domicilio Fiscal </b> no debe estar vacío.',
      codigoPostal: 'El campo <b> Codigo Postal del Domicilio Fiscal </b> no debe estar vacío.',
      estado: 'El campo <b> Estado del Domicilio Fiscal </b> debe estar seleccionado.',
      municipio: 'El campo <b> Municipio del Domicilio Fiscal </b> debe estar seleccionado.',
      localidad: 'El campo <b> Localidad del Domicilio Fiscal </b> debe estar seleccionado.',
      correoElectronico: 'Por favor verifica que el campo <b> Correo Electrónico de los Medios de Contacto</b> no este vacío o que el formato proporcionado sea válido.<br><b> formato correo: </b> nombre@ejemplo.com',
      numeroTelefono: 'El campo <b> Número Teléfono de los Medios de Contacto  </b> debe contener 10 números.',
      rfc: 'Por favor verifica que el campo <b> RFC </b> no este vacío o que el formato proporcionado sea válido.<br><b> formato válido: </b> LLLL000000AAA',
      curp: 'Por favor verifica que el campo <b> CURP </b> no este vacío o que el formato proporcionado sea válido.<br><b> formato válido: </b> LLLL000000LLLLLLA0',
      nombre: 'El campo <b> Nombre de los Datos del Representante Legal </b> no debe estar vacío.',
      apellidoPaterno: 'El campo <b> Apellido Paterno de los Datos del Representante Legal </b> no debe estar vacío.',
      apellidoMaterno: 'El campo <b> Apellido Materno de los Datos del Representante Legal </b> no debe estar vacío.',
      sexo: 'El campo <b> Sexo de los Datos del Representante Legal </b> no debe estar vacío.',
      fechaNacimiento: 'El campo <b> Fecha Nacimiento de los Datos del Representante Legal </b> no debe estar vacío.',
      documentos: 'Para continuar a la sección de <b>Documentos</b> primero debes marcar el cuadro que aparece en la parte inferior de esta sección',
      actaConstitutiva: 'El documento <b>Acta Constitutiva</b> no se ha seleccionado.',
      factura: 'El documento <b>Factura</b> no se ha seleccionado.',
      ine: 'El documento <b>INE REPRESENTANTE LEGAL</b> no se ha seleccionado.',
      poderNotarial: 'El documento <b>Poder Notarial</b> no se ha seleccionado.',
      repuveDoc: 'El documento <b>REPUVE</b> no se ha seleccionado.',
      solicitud: 'El documento <b>Solicitud</b> no se ha seleccionado.',
      tenencia: 'El documento <b>Tenencia</b> no se ha seleccionado.',
      terminosCondiciones: '<b>Debes Aceptar los Términos y Condiciones</b>',
    };
    return mensajes[campo] || `El campo ${campo.replace(/([A-Z])/g, ' $1').toLowerCase()} es no valido o está incompleto.`;
  }


  private showAlert(titulo: string, texto: string, icono: 'error' | 'warning' | 'info' | 'success') {
    Swal.fire({
      title: titulo,
      html: texto,
      icon: icono,
      confirmButtonColor: '#A11A5C',
      confirmButtonText: 'Confirmar',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }


  //********************************************* BOTONES SIGUIENTE (AJUSTAR NOMBRES DE CAMPO SI ES NECESARIO) ************************************************//

  nextButtonClick() {
    this.validarYContinuar({
      grupo: this.PrimerFormGroup,
      nombres: ['niv', 'placa', 'motivo', 'certificadoPor', 'tipoServicio',
        'categoria', 'marca', 'submarca', 'modelo', 'motor', 'repuve','refrendo'
      ],
    });
  }

  nextButtonClick2() {
    this.validarYContinuar({
      grupo: this.SegundoGrupo,
      nombres: ['rfcMoral', /* Validar también los campos que ahora son obligatorios si no vienen del servicio */ 'fechaConstitucion', 'razonSocial', 'calle', 'numExterior', 'codigoPostal', 'estado', 'municipio', 'localidad'],
    });
  }

  nextButtonClick3() {
    this.validarYContinuar({
      grupo: this.TercerFormGroup,
      nombres: ['numeroTelefono', 'correoElectronico'],
    });
  }

  nextButtonClick4() {
    this.validarYContinuar({
      grupo: this.CuartoFormGroup,
      nombres: ['rfc', 'curp', 'nombre', 'apellidoPaterno', 'apellidoMaterno', 'sexo', 'fechaNacimiento'],
    });
  }

  nextButtonClick5() {
    this.validarYContinuar({
      grupo: this.QuintoFormGroup,
      nombres: ['documentos'],
    });
  }

  nextButtonClick6() {
    // 1. Inicia con la lista de documentos que SIEMPRE son obligatorios.
    const nombresAValidar = [
      'actaConstitutiva',
      'factura',
      'ine',
      'poderNotarial',
      'repuveDoc',
      'solicitud'
    ];

    // 2. Si el trámite es foráneo, AÑADE 'tenencia' a la lista.
    if (this.esForaneo) {
      nombresAValidar.push('tenencia');
    }

    // 3. Pasa la lista (que ahora es dinámica) a la función de validación.
    this.validarYContinuar({
      grupo: this.SextoFormGroup,
      nombres: nombresAValidar,
    });
  }

  nextButtonClick7() {
    // Primero validar el último paso
    const terminosControl = this.SeptimoFormGroup.get('terminosCondiciones');
    terminosControl?.markAsTouched();
    this.actualizarEstilosCampo('terminosCondiciones', terminosControl!);

    if (this.SeptimoFormGroup.invalid) {
      Swal.fire({
        html: '<b>Debes Aceptar los Términos y Condiciones</b>',
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      return;
    }

    // Verificar que todos los formularios anteriores sean válidos antes de enviar
    let todosLosPasosValidos = true;

    for (const fg of [this.PrimerFormGroup, this.SegundoGrupo, this.TercerFormGroup, this.CuartoFormGroup, this.SextoFormGroup]) {
      if (fg.invalid) {
        todosLosPasosValidos = false;
        Object.values(fg.controls).forEach(control => control.markAsTouched());

        Swal.fire({
          html: 'Formulario Incompleto, Por favor, revise los pasos anteriores. Hay campos obligatorios sin llenar o con errores.',
          icon: 'error',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Confirmar',
        });

        break; // Importante: salir del loop si uno falla
      }
    }

    if (!todosLosPasosValidos) {
      return;
    }

    // ✅ Solo si todos los formularios fueron válidos, guardamos
    Swal.fire({
      title: '¿Estás seguro que deseas guardar la información?',
      icon: 'question',
      confirmButtonColor: '#04B404',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      showCancelButton: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.esTramiteEstatal) {
          this.guardarCambiosEstatal();
        } else {
          this.guardarCambiosForaneo();
        }
      } else {
        console.log('El guardado fue cancelado por el usuario.');
      }
    });
  }

  guardarCambiosEstatal(): void {
    const payload: PayloadEdicionEstatal = {
      dataEncript: this.dataEncript!,
      documentoList: this.construirListaDocumentosPayload()

    };

    this.mostrarSpinner = true;

    this.guardarEdicionService.guardarEstatal(payload).subscribe({
      next: () => {
        this.mostrarSpinner = false;
        Swal.fire({
          title: '¡Éxito!',
          icon: 'success',
          html: 'Los cambios han sido guardados correctamente.',
          confirmButtonColor: '#04B404',
          confirmButtonText: 'Aceptar',
          showCancelButton: false,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirigir a la ruta deseada
            this.router.navigate(['https://tlaxcallan.sefintlax.gob.mx/tlaxcallan']);
          }
        });
      },
      error: () => {
        this.mostrarSpinner = false;
        Swal.fire('Error', 'No se pudieron guardar los cambios.', 'error');
      }
    });

  }

  /**
   * Prepara y envía el payload para un trámite FORÁNEO.
   */
  guardarCambiosForaneo(): void {
    // Validar que todos los formularios sean válidos antes de enviar
    if (this.PrimerFormGroup.invalid || this.SegundoGrupo.invalid || this.TercerFormGroup.invalid || this.CuartoFormGroup.invalid) {
      Swal.fire('Formulario Incompleto', 'Por favor, revise todos los pasos. Hay campos obligatorios sin rellenar o con errores.', 'error');
      return;
    }

    let localidadForanea = this.SegundoGrupo.value.localidad;
    if (!localidadForanea && this.asentamiento) {
      localidadForanea = this.asentamiento;
    }

    const idLocalidadCG = Number(localidadForanea);
    if (isNaN(idLocalidadCG)) {
      Swal.fire('Error de Datos', 'No se ha podido determinar la localidad del domicilio fiscal. Por favor, verifique el Código Postal.', 'error');
      return; // Detenemos el envío si la localidad no es válida.
    }

    const payload: PayloadEdicionForaneo = {
      dataEncript: this.dataEncript!,
      // Primer Grupo
      strNiv: this.PrimerFormGroup.value.niv,
      strPlaca: this.PrimerFormGroup.value.placa,
      strMarca: this.PrimerFormGroup.value.marca,
      strCategoria: this.PrimerFormGroup.value.categoria,
      strSubMarca: this.PrimerFormGroup.value.submarca,
      strModelo: this.PrimerFormGroup.value.modelo,
      strMotor: this.PrimerFormGroup.value.motor,
      strRepuve: this.PrimerFormGroup.value.repuve,
      strRefrendo: this.PrimerFormGroup.value.refrendo,
      // Segundo Grupo
      strRfc: this.SegundoGrupo.value.rfcMoral,
      strRazonSocial: this.SegundoGrupo.value.razonSocial,
      strFechaConstitucion: this.SegundoGrupo.value.fechaConstitucion,
      strCalleFiscal: this.SegundoGrupo.value.calle,
      strNumeroExteriorFiscal: this.SegundoGrupo.value.numExterior,
      strNumeroInteriorFiscal: this.SegundoGrupo.value.numInterior,
      strCodigoPostalFiscal: this.SegundoGrupo.value.codigoPostal,
      strEstadoFiscal: this.SegundoGrupo.value.estado,
      strMunicipioFiscal: this.SegundoGrupo.value.municipio,
      //tercer grupo
      intiICodigoPostalCg: idLocalidadCG,
      intIdEstadoFiscal: parseInt(this.idEstado),
      intIdMunicipioFiscal: parseInt(this.idMunicipio),
      strLocalidadFiscal: localidadForanea,
      //  intIdLocalidadFiscal: this.TercerFormGroup.value.localidad,
      // Cuarto Grupo
      strRfcRepresentante: this.CuartoFormGroup.value.rfc,
      strCurpRepresentante: this.CuartoFormGroup.value.curp,
      strNombreRepresentante: this.CuartoFormGroup.value.nombre,
      strApPaternoRepresentante: this.CuartoFormGroup.value.apellidoPaterno,
      strApMaternoRepresentante: this.CuartoFormGroup.value.apellidoMaterno,
      strSexoRepresentante: this.CuartoFormGroup.value.sexo,
      strFechaNacimientoRepresentante: this.CuartoFormGroup.value.fechaNacimiento,
      // Documentos
      documentoList: this.construirListaDocumentosPayload()
    };

    this.mostrarSpinner = true;

    // --- DESCOMENTA Y USA TU SERVICIO REAL ---
    this.guardarEdicionService.guardarForaneo(payload).subscribe({
      next: () => {
        this.mostrarSpinner = false;
        Swal.fire({
          title: '¡Éxito!',
          icon: 'success',
          html: 'Los cambios han sido guardados correctamente.',
          confirmButtonColor: '#04B404',
          confirmButtonText: 'Aceptar',
          showCancelButton: false,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirigir a la ruta deseada
            this.router.navigate(['https://af-oficina-virtual.sefintlax.gob.mx/ventanilla-unica']);
          }
        });
      },
      error: () => {
        this.mostrarSpinner = false;
        Swal.fire('Error', 'No se pudieron guardar los cambios.', 'error');
      }
    });

    setTimeout(() => this.mostrarSpinner = false, 1500); // Simulación
  }

  /**
   * Crea la lista de documentos para los payloads de guardado.
   */
  construirListaDocumentosPayload(): DocumentoPayload[] {
    const lista: DocumentoPayload[] = [];
    this.documentos.forEach(doc => {
      // Incluir solo si el documento ha sido cargado/actualizado y tiene la información necesaria
      if (doc.idDocumentoBack && doc.nombreEncriptado && doc.esNuevo) {
        lista.push({
          idDocumento: doc.idDocumentoBack,
          url: doc.rawUrl, // o el campo que corresponda
          idDocumentoTramite: parseInt(doc.id, 10),
          nombreDocumento: doc.nombreEncriptado, // o el nombre real del archivo
          // estatus: doc.status,
        });
      }
    });
    return lista;
  }

  catCoberturaCertificados() {
    this.catCoberturaCertificadoService.catCoberturaCertificado().subscribe({
      next: (data: any) => {
        this.coberturaCertificados = data;

      }
    });
  }

  catEfectoCertificado() {
    this.catEfectoCertificadoService.catEfectoCertificado().subscribe({
      next: (data: any) => {
        this.efectosCertificados = data;

      }
    });
  }

  onChangeCoberturaCertificados(event: any) {
    this.solicitudVo.strCertificadoPor = event.target.value;

  }

  onChangeEfectoCertificado(event: any) {
    this.solicitudVo.strMotivoSolicitud = event.target.value;

  }

  documentos: any[] = [];
  documentosBase = [
    {
      id: '1',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'ACTA CONSTITUTIVA',
      formControlName: 'actaConstitutiva',
      estadoSubida: 'PENDIENTE',
      urlVisor: null as SafeResourceUrl | null,
      rawUrl: '',
      estatus: '',
      esNuevo: false,
    },
    {
      id: '3',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'FACTURA',
      formControlName: 'factura',
      estadoSubida: 'PENDIENTE',
      urlVisor: null as SafeResourceUrl | null,
      rawUrl: '',
      estatus: '',
      esNuevo: false,
    }, // Corregido ID para coincidir con formControlName
    {
      id: '5',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'INE REPRESENTANTE LEGAL',
      formControlName: 'ine',
      estadoSubida: 'PENDIENTE',
      urlVisor: null as SafeResourceUrl | null,
      rawUrl: '',
      estatus: '',
      esNuevo: false,
    },
    {
      id: '6',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'PODER NOTARIAL',
      formControlName: 'poderNotarial',
      estadoSubida: 'PENDIENTE',
      urlVisor: null as SafeResourceUrl | null,
      rawUrl: '',
      estatus: '',
      esNuevo: false,
    },
    {
      id: '7',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'REPUVE',
      formControlName: 'repuveDoc',
      estadoSubida: 'PENDIENTE',
      urlVisor: null as SafeResourceUrl | null,
      rawUrl: '',
      estatus: '',
      esNuevo: false,
    }, // formControlName para el documento REPUVE
    {
      id: '8',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'SOLICITUD',
      formControlName: 'solicitud',
      estadoSubida: 'PENDIENTE',
      urlVisor: null as SafeResourceUrl | null,
      rawUrl: '',
      estatus: '',
      esNuevo: false,
    },
    {
      id: '9',
      idDocumentoBack: '',
      titulo: 'TENENCIA Y/O REFRENDO',
      formControlName: 'tenencia',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: '',
      estatus: '',
      esNuevo: false,
    },
  ];

  /**
   * Construye la lista de documentos que se mostrarán en la interfaz,
   * basándose en si el trámite es foráneo o no.
   */
  inicializarListaDocumentos(): void {
    // Siempre empezamos con una copia de todos los documentos base.
    let documentosVisibles = [...this.documentosBase];

    // Si el trámite NO es foráneo, quitamos el documento de Refrendo.
    if (!this.esForaneo) {
      documentosVisibles = documentosVisibles.filter(doc => doc.formControlName !== 'tenencia');
    }

    // Asignamos el resultado final a la lista que usa la plantilla HTML.
    this.documentos = documentosVisibles;
  }

  //********************************** MÉTODOS PARA DOCUMENTOS (SIN CAMBIOS SIGNIFICATIVOS) *********************************************//

  onFileSelected(input: HTMLInputElement, doc: any): void {
    const nuevoArchivo = input.files?.[0];
    if (!nuevoArchivo) return;

    // --- Lógica de validación del archivo (sin cambios) ---
    if (nuevoArchivo.type !== 'application/pdf') { /* ... Swal error ... */
      return;
    }
    const maxSizeMB = 10;
    if (nuevoArchivo.size > maxSizeMB * 1024 * 1024) { /* ... Swal error ... */
      return;
    }

    const rfc = this.SegundoGrupo.get('rfcMoral')?.value;
    if (!rfc) { /* ... Swal error ... */
      return;
    }

    // ====================================================================
    // ===== INICIA LÓGICA NUEVA: ¿REEMPLAZAR O SUBIR POR PRIMERA VEZ? =====
    // ====================================================================

    if (doc.idDocumentoBack) {
      // Si ya hay un archivo, preguntamos al usuario si quiere reemplazarlo.
      Swal.fire({
        title: '¿Reemplazar archivo?',
        text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#41bd00',
        cancelButtonColor: '#C71128',
        confirmButtonText: 'Sí, reemplazar',
        cancelButtonText: 'No, cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // El usuario quiere reemplazar. Primero eliminamos, luego subimos.
          this.eliminarYSubir(doc, nuevoArchivo, rfc, input);
        } else {
          // El usuario canceló, limpiamos el input para que no quede el archivo seleccionado.
          input.value = '';
        }
      });
    } else {
      this.subirNuevoDocumento(doc, nuevoArchivo, rfc, input);
    }
  }

  /*
   * Orquesta la eliminación del archivo antiguo y luego la subida del nuevo.
   */
  private eliminarYSubir(doc: any, nuevoArchivo: File, rfc: string, input: HTMLInputElement): void {
    Swal.fire({
      title: 'Eliminando archivo anterior...',
      didOpen: () => Swal.showLoading(),
      showConfirmButton: false
    });
    this.eliminarDocumentoService.eliminarDocumentos(doc.idDocumentoBack as number, rfc, doc.nombreEncriptado)
      .pipe(
        // switchMap encadena la llamada de subida DESPUÉS de que la eliminación sea exitosa
        switchMap(() => {
          Swal.update({text: 'Subiendo nuevo archivo...'});
          return this.documentoService.subirDocumentoPdf(rfc, doc.id, nuevoArchivo);
        })
      ).subscribe({
      next: (event: HttpEvent<any>) => this.manejarEventosDeSubida(event, doc, nuevoArchivo),
      error: err => {
        this.showAlert("Error", 'No se pudo eliminar el archivo anterior. La subida del nuevo archivo ha sido cancelada.', "error")
        doc.estadoSubida = 'ERROR';
        input.value = '';
      }
    });
  }

  /**
   * Sube un documento que no tiene un predecesor a eliminar.
   */
  private subirNuevoDocumento(doc: any, nuevoArchivo: File, rfc: string, input: HTMLInputElement): void {
    doc.estadoSubida = 'CARGANDO';
    this.isUploading[doc.id] = true;
    this.uploadProgress[doc.id] = 0;
    this.documentoService.subirDocumentoPdf(rfc, doc.id, nuevoArchivo).subscribe({
      next: (event: HttpEvent<any>) => this.manejarEventosDeSubida(event, doc, nuevoArchivo),
      error: err => {
        doc.estadoSubida = 'ERROR';
        this.isUploading[doc.id] = false;
        input.value = '';
        Swal.fire('Error de Subida', `No se pudo subir el documento: ${doc.titulo}.`, 'error');
      }
    });
  }

  /*
   * Lógica centralizada para manejar los eventos de progreso y respuesta de la subida.
   */
  private manejarEventosDeSubida(event: HttpEvent<any>, doc: any, archivo: File): void {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        if (event.total) {
          this.uploadProgress[doc.id] = Math.round(100 * (event.loaded / event.total));
        }
        break;
      case HttpEventType.Response:
        this.uploadProgress[doc.id] = 100;
        doc.estadoSubida = 'COMPLETADO';
        this.isUploading[doc.id] = false;

        // Guardamos los datos importantes de la respuesta en nuestro objeto 'doc'
        doc.nombreEncriptado = event.body.identificador;
        doc.idDocumentoBack = event.body.idDocumento;
        doc.esNuevo = true;
        doc.estatus = "false";

        // Actualizamos el FormGroup para que el campo sea válido
        this.SextoFormGroup.get(doc.formControlName)?.setValue(doc.idDocumentoBack);
        this.SextoFormGroup.get(doc.formControlName)?.updateValueAndValidity();

        // Generamos la vista previa
        const localUrlString = URL.createObjectURL(archivo);
        doc.rawUrl = localUrlString;
        doc.urlVisor = this.sanitizer.bypassSecurityTrustResourceUrl(localUrlString);

        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `${doc.titulo} subido con éxito`,
          showConfirmButton: false,
          timer: 3000
        });
        break;
    }
  }

  verDocumentoEnVentana(doc: any): void {
    // Verificamos que la propiedad rawUrl (que ahora es la URL local) exista
    if (doc && doc.rawUrl) {
      window.open(doc.rawUrl, '_blank');
    } else {
      Swal.fire({
        icon: 'info',
        title: 'No disponible',
        text: 'Primero debe seleccionar un archivo para poder visualizarlo.'
      });
    }
  }


  //*********************************************-MODALES RFC Y CURP (SIN CAMBIOS)-************************************************//
 modalRFCmoral() {
  Swal.fire({
    background: 'rgba(66, 43, 124)',
    imageUrl: '/assets/img/imagenesCuerpo/RFCMORAL.png',
    imageWidth: '95%',
    imageHeight: 'auto',
    showCloseButton: true,
    showConfirmButton: false,
    width: '60%',
    showClass: {
      popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `,
    },
    hideClass: {
      popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                  `,
    },
  });
}

//---------------------------------------------------------------------------------------
modalRFC() {
  Swal.fire({
    background: 'rgba(66, 43, 124)',
    imageUrl: '/assets/img/imagenesCuerpo/RFCFISICA.png',
    imageWidth: '95%',
    imageHeight: 'auto',
    showCloseButton: true,
    showConfirmButton: false,
    width: '60%',
    showClass: {
      popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `,
    },
    hideClass: {
      popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                  `,
    },
  });
}

//---------------------------------------------------------------------------------------
modalCURP() {
  Swal.fire({
    background: 'rgba(66, 43, 124)',
    imageUrl: '/assets/img/imagenesCuerpo/CURP.png',
    imageWidth: '95%',
    imageHeight: 'auto',
    showCloseButton: true,
    showConfirmButton: false,
    width: '60%',
    showClass: {
      popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `,
    },
    hideClass: {
      popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                  `,
    },
  });
}

  // Méto do que "transfiere" valor automáticamente del RFC al CURP (Representante Legal)
  pasarValorRfcACurp(): void {
    const rfcControl = this.CuartoFormGroup.get('rfc');
    const curpControl = this.CuartoFormGroup.get('curp');

    if (rfcControl && curpControl) {
      const rfcValue = (rfcControl.value || '').toUpperCase();

      // Si el RFC tiene al menos 10 caracteres, copia esa parte al CURP
      if (rfcValue.length >= 10) {
        curpControl.setValue(rfcValue.substring(0, 10));
      } else {
        curpControl.setValue(rfcValue); // Si no, copia lo que haya
      }
    }
  }


  descargarDocumento() {

    // 1. Mostrar un indicador de carga
    Swal.fire({
      html: `<h4>Descargando documento <b style="color: #A11A5C">SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN</b><hr>espere un momento...</h4>`,
      didOpen: () => {
        Swal.showLoading();
      },
      timer: 4000,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });

    // 2. Recolectar todos los datos desde tus formularios
    // NOTA: Asegúrate de que los nombres de los formControlName coincidan
    //    const nombreCompleto = `${this.CuartoFormGroup.get('nombre')?.value}  ${this.QuintoFormGroup.get('apellidoPaterno')?.value} ${this.QuintoFormGroup.get('apellidoMaterno')?.value}`;
    const nombre = this.CuartoFormGroup.get('nombre')?.value || '';
    const paterno = this.CuartoFormGroup.get('apellidoPaterno')?.value || '';
    const materno = this.CuartoFormGroup.get('apellidoMaterno')?.value || '';

    const nombreCompleto = `${nombre} ${paterno} ${materno}`.trim();

    const rfc = this.SegundoGrupo.get('rfcMoral')?.value;
    const rfcReprecentante = this.CuartoFormGroup.get('rfc')?.value;
    const razonSocial = this.SegundoGrupo.get('razonSocial')?.value;
    const curp = this.CuartoFormGroup.get('curp')?.value; // O el que corresponda
    const domicilio = `${this.SegundoGrupo.get('calle')?.value} ${this.TercerFormGroup.get('numExterior')?.value || ''}`;
    const municipio = this.SegundoGrupo.get('municipio')?.value;
    const estado = this.SegundoGrupo.get('estado')?.value;

    const certificadoId = this.PrimerFormGroup.get('certificadoPor')?.value;
    const certificadoSeleccionado = this.coberturaCertificados.find(
      certificado => certificado.id_cobertura_certificado == certificadoId
    );
    const garantias = certificadoSeleccionado ? certificadoSeleccionado.certificado_por : '';

    const niv = this.PrimerFormGroup.get('niv')?.value;
    const placa = this.PrimerFormGroup.get('placa')?.value;
    const marca = this.PrimerFormGroup.get('marca')?.value;
    const estadoVehiculo = 'Tlaxcala'

    const modelo = this.PrimerFormGroup.get('modelo')?.value;
    const refrendo = this.PrimerFormGroup.get('refrendo')?.value;
    let tipoServicio: string;
    if (this.PrimerFormGroup.get('tipoServicio')?.value === '1') {
      tipoServicio = "PÚBLICO";
    } else {
      tipoServicio = "PRIVADO";
    }
    const motor = this.PrimerFormGroup.get('motor')?.value;
    const repuve = this.PrimerFormGroup.get('repuve')?.value;
    const tipoPersona = 'M';

    // 3. Llamar al servicio con todos los datos recolectados
    this.imprimirSolicitudService.imprimirSolicitudCdniGenerico(
      nombreCompleto, rfc, rfcReprecentante, razonSocial, curp, domicilio, municipio, estado, garantias, niv,
      placa, marca, estadoVehiculo, modelo, refrendo, tipoServicio, motor, repuve, tipoPersona
    ).subscribe({
      next: (data: Blob) => {
        // 4. Lógica para procesar la respuesta y descargar el archivo
        Swal.close(); // Cerrar el indicador de carga
        const blob = new Blob([data], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);

        // Crear un enlace temporal para iniciar la descarga
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Solicitud_No_Infraccion.pdf'; // Nombre del archivo

        // Simular clic en el enlace y luego removerlo
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

        // Limpiar la URL del objeto creado para liberar memoria
        window.URL.revokeObjectURL(url);
        link.remove();
      },
      error: (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error en la descarga',
          text: 'No se pudo generar el documento. Por favor, inténtelo de nuevo más tarde.'
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.subCodigoPostal?.unsubscribe();
  }


} // Fin de la clase PersonaMoralEdicionComponent


function inferirDatosDesdeCurp(curp: string): { sexo: string, fechaNacimiento: string } | null {
  if (typeof curp !== 'string' || curp.length !== 18) {
    return null;
  }

  try {
    const fechaSubstr = curp.substring(4, 10);
    const sexoChar = curp.charAt(10).toUpperCase();
    const anioDosDigitos = parseInt(fechaSubstr.substring(0, 2), 10);
    const diferenciadorSiglo = curp.charAt(16);
    const siglo = isNaN(parseInt(diferenciadorSiglo)) ? '20' : '19';
    const anioCompleto = siglo + anioDosDigitos.toString().padStart(2, '0');
    const mes = fechaSubstr.substring(2, 4);
    const dia = fechaSubstr.substring(4, 6);
    const fechaFormateada = `${anioCompleto}-${mes}-${dia}`; // Formato AAAA-MM-DD
    const sexo = sexoChar === 'H' ? 'MASCULINO' : 'FEMENINO'; // Formato de texto completo
    const fechaObjeto = new Date(fechaFormateada);

    if (isNaN(fechaObjeto.getTime())) {
      return null;
    }

    return {
      sexo: sexo,
      fechaNacimiento: fechaFormateada
    };
  } catch (error) {
    return null;
  }
}